import { useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { useAdsContext, useShipmentDetailsContext, useShipmentsOverviewContext } from '@/modules/pmt/context';
import { AdSetups } from '../../constants';
import { DelayedShipmentPopup } from '../DelayedShipmentPopup';
import { ESConnectFailedDialog } from '../ESConnectFailedDialog';
import { InboxAccessDialog } from '../InboxAccessDialog';
import { MyParcelsLeftAd } from '../MyParcelsLeftAd';
import { MyParcelsRightSection } from '../MyParcelsRightSection';
import { PMTSeoSection } from '../PMTSeoSection';
import { RequestLoginDialog } from '../RequestLoginDialog';
import { ShipmentsOverview } from '../ShipmentsOverview';
import { TrackingDetails } from '../TrackingDetails';
import { TrackingOnboardingPopup } from '../TrackingOnboardingPopup';
import AppBadgeSection from './AppBadgeSection';
import { InnerLayoutContainer, LayoutContainer, LeftSection, RightSection } from './MyParcelsLayout.styles';

export const MyParcelsLayout = () => {
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);
  const { showDetailsView } = useShipmentDetailsContext();
  const { noShipmentsAdded } = useShipmentsOverviewContext();
  const { currentAdSetup } = useAdsContext();

  if (isDesktopPMT)
    return (
      <>
        <TrackingOnboardingPopup />
        <DelayedShipmentPopup />
        <ESConnectFailedDialog />
        <InboxAccessDialog />
        <RequestLoginDialog />
        <LayoutContainer minHeight={noShipmentsAdded && currentAdSetup === AdSetups.SETUP_B ? 648 : 0}>
          <InnerLayoutContainer>
            <LeftSection>
              <ShipmentsOverview />
              <AppBadgeSection />
              <MyParcelsLeftAd />
            </LeftSection>
            <RightSection>
              <MyParcelsRightSection />
            </RightSection>
          </InnerLayoutContainer>
        </LayoutContainer>
        <PMTSeoSection />
      </>
    );

  return (
    <>
      <TrackingOnboardingPopup />
      <DelayedShipmentPopup />
      <ESConnectFailedDialog />
      <InboxAccessDialog />
      <RequestLoginDialog />
      <LayoutContainer>
        <InnerLayoutContainer>
          {!showDetailsView && (
            <LeftSection>
              <ShipmentsOverview />
            </LeftSection>
          )}
          {/* TODO: Investigate why not check showDetailsView here on mobile
          Issue: All Shipment Details's hooks was called even this section is not shown on user view */}
          <TrackingDetails />
        </InnerLayoutContainer>
      </LayoutContainer>

      <AppBadgeSection />

      {!showDetailsView && <PMTSeoSection />}
    </>
  );
};
